import CompetitionStep from '../components/Steps/CompetitionStep';
import DivisionStep from '../components/Steps/DivisionStep';
import TeamBuilderStep from '../components/Steps/TeamBuilderStep';
import TeamMemberBuilderStep from '../components/Steps/TeamMemberBuilderStep';
import TeamIndexStep from '../components/Steps/TeamIndexStep';
import BreadC from '../components/BreadCrumbs';

import { useState, useEffect } from 'react';
import { useAlert } from '../context/AlertContext';

// Hooks
import { useCompetitions } from '../hooks/useCompetitions';
import { useCompetitionEvents } from '../hooks/useCompetitionEvents';
import { useTeamIndex } from '../hooks/useTeamIndex';

// Api
import { initializeTeam, updateCompetitionTeam } from '../api/api';

// src/pages/Dashboard.js
export default function Dashboard({step, setStep}) {
  const { showAlert } = useAlert();

  // Competition data
  const competitions = useCompetitions();
  const [selectedCompetition, setSelectedCompetition] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dates, setDates] = useState([]); 

  // Team builder state
  const [teamMembers, setTeamMembers] = useState([]);
  const [team, setTeam] = useState('');
  const [divisionSelection, setDivisionSelection] = useState('Setter');
  const [editingTeam, setEditingTeam] = useState(false);
  const [editingTeamId, setEditingTeamId] = useState()

  // Fetch teams when in index view
  const teamIndexList = useTeamIndex(
    selectedCompetition?.name,
    selectedDate,
    step,
  );

 const handleTeamSubmit = async (teamPayload) => {
  let res;
  if (teamPayload.isEditing) {
    res = await updateCompetitionTeam({
      id: teamPayload.editingTeamId,
      name: teamPayload.name,
      division_selection: teamPayload.division_selection,
      address: teamPayload.address,
      office_name: teamPayload.office_name,
      office_restriction: teamPayload.office_restriction,
      division: teamPayload.division,
      last_modified_by: teamPayload.last_modified_by
    });
  } else {
    res = await initializeTeam({
      name: teamPayload.name,
      division_selection: teamPayload.division_selection,
      address: teamPayload.address,
      competition_event_id: teamPayload.competition_event_id,
      competition_id: teamPayload.competition_id,
      creator_employee_id: teamPayload.creator_employee_id,
      office_name: teamPayload.office_name,
      office_restriction: teamPayload.office_restriction,
      division: teamPayload.division,
      last_modified_by: teamPayload.last_modified_by
    });
  }
  
  setTeam(res)
  setStep(3)
};
 
  // Initialize default competition
  useEffect(() => {
    if (competitions.length) {
      setSelectedCompetition(competitions[0]);
      setDates(competitions[0].competition_events);
    }
  }, [competitions]);


  useEffect(() => {
    if (selectedCompetition) {
      setSelectedDate(dates[0])
    }
  }, [dates])

  useEffect(() => {
    setDates(selectedCompetition ? selectedCompetition.competition_events : []);
  }, [selectedCompetition]);

  const goToNext = () => {
    if (!selectedCompetition) {
      showAlert(['Select a competition first.'], 'error');
      return;
    }
    setStep(selectedCompetition.division_split ? 1 : 2);
  };

  const createTeam = async (address) => {
    return 
  };

  return (
    <main className="max-w-screen min-h-screen flex flex-col items-center justify-center pt-[65px] pb-[20px] md:px-8">
      {step === 0 && (
        <CompetitionStep
          competitions={competitions}
          selectedCompetition={selectedCompetition}
          dates={dates}
          setSelectedCompetition={setSelectedCompetition}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          onNext={goToNext}
        />
      )}
      {step === 1 && (
        <DivisionStep
          divisionSelection={divisionSelection}
          setDivisionSelection={setDivisionSelection}
          setStep={setStep}
          competition={selectedCompetition}
          onNext={() => setStep(2)}
        />
      )}
      {step === 2 && (
        <TeamBuilderStep
          competition={selectedCompetition}
          competitionDate={selectedDate}
          divisionSelection={divisionSelection}
          setTeam={setTeam}
          editingTeam={editingTeam}
          editingTeamId={editingTeamId}
          onSubmit={handleTeamSubmit}
        />
      )}
      {step === 3 && (
        <TeamMemberBuilderStep
          competition={selectedCompetition}
          competitionDate={selectedDate}
          teamMembers={teamMembers}
          setTeamMembers={setTeamMembers}
          divisionSelection={divisionSelection}
          createTeam={createTeam}
          editingTeam={editingTeam}
          team={team}
          setStep={setStep}
          setTeam={setTeam}
          setEditingTeam={setEditingTeam}
          setEditingTeamId={setEditingTeamId}
        />
      )}
      {step === 4 && (
        <TeamIndexStep
          competition={selectedCompetition}
          teamIndexList={teamIndexList}
          setEditingTeam={setEditingTeam}
          setTeamMembers={setTeamMembers}
          setTeam={setTeam}
          setStep={setStep}
          selectedDate={selectedDate}
          step={step}
          setEditingTeamId={setEditingTeamId}
        />
      )}

      {step !== 5 && step !== 4 && (
        <BreadC
          step={step}
          setStep={setStep}
          competition={selectedCompetition}
          divisionSelection={divisionSelection}
          setEditingTeam={setEditingTeam}
          setTeam={setTeam}
          team={team}
          editingTeam={editingTeam}
        />
      )}
    </main>
  );
}
